/**
 * Convert an upload path (`/api/uploads/<key>`) into a thumbnail URL of the
 * given width, served by the backend at `/api/thumb/<key>?w=<w>`.
 *
 * Allowed widths (server-side): 200, 400, 600, 800, 1200. Pick whichever
 * matches your rendered tile size for crispest results & smallest payload.
 *
 * Non-matching URLs (external HTTPS, data URIs, etc.) are returned as-is so
 * this helper is safe to call on any source.
 *
 * @param {string} url
 * @param {number} w
 * @returns {string}
 */
export function thumbUrl(url, w = 600) {
    if (!url || typeof url !== "string") return url;
    const m = url.match(/\/uploads\/(.+)$/);
    if (!m) return url;
    return `/api/thumb/${m[1]}?w=${w}`;
}
